/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ q: NonNullable<unknown> }} Partner_Billing_Board_Cond_QInputs */



/**
* | output |
* | --- |
* | "named like “{q}”" |
*
* @param {Partner_Billing_Board_Cond_QInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_cond_q = /** @type {((inputs: Partner_Billing_Board_Cond_QInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Cond_QInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`benannt wie „${i?.q}“`)
	return /** @type {LocalizedString} */ (`named like “${i?.q}”`)
});